import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propBool, propShape, propStr, } from '../../../../../helpers/custom-prop-types';
import BlockIcon from '../../../../Icon/Svg/BlockIcon';
const BlockButtonInput = (props) => {
    const { className, disabled, input, label } = props;
    return (_jsxs("label", Object.assign({ className: className }, { children: [_jsx("input", Object.assign({}, input, { disabled: disabled, type: 'checkbox' })), label && _jsx("span", Object.assign({ className: 'block_column_text' }, { children: label })), _jsx(BlockIcon, { className: 'block_column_icon' })] })));
};
BlockButtonInput.propTypes = {
    className: propStr().isRequired,
    disabled: propBool(),
    input: propShape(),
    label: propStr(),
};
BlockButtonInput.defaultProps = {
    disabled: false,
    input: null,
    label: '',
};
export default BlockButtonInput;
